"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _celesteStoreProvider = require("../celeste-store-provider");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/* eslint-disable eqeqeq */

var TargetNetworkWrapper = function TargetNetworkWrapper(_ref) {
  var children = _ref.children,
    info = _ref.info,
    network = _ref.network;
  var _useCelesteSelector = (0, _celesteStoreProvider.useCelesteSelector)(function (state) {
      return state;
    }),
    walletReducer = _useCelesteSelector.walletReducer;

  // prettier-ignore
  return +walletReducer.chainId === +network ? children : /*#__PURE__*/_react["default"].createElement("div", null, info);
};
TargetNetworkWrapper.propTypes = {
  children: _propTypes["default"].node,
  info: _propTypes["default"].element,
  network: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired
};
var _default = TargetNetworkWrapper;
exports["default"] = _default;